import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";

import { LoadingComponent, SnackbarCommonComponent } from "../components/common";
import SidebarComponent from "../components/home/sidebarComponent";
import EasyPaySlipPtyRegisterComponent from "../components/easyPaySlipPty/easyPaySlipPtyRegisterComponent";
import { SessionUserStyles } from "./PagesStyle";
import { mapMessageCodeToIcon } from "../helpers/extensions";
import { cleanMessage } from "../actions/EasyPaySlipPtyActions";

class EasyPaySlipPtyRegisterPage extends Component {
	render() {
		const {
			classes, isLoading, message, messageCode, cleanMessageInternal, mixpanel
		} = this.props;

		return (
			<div className={classes.root}>
				<CssBaseline />
				<SidebarComponent />
				<main className={classes.content}>
					<LoadingComponent isLoading={isLoading} />
					<SnackbarCommonComponent key="SnackBarUpdateAccountantDetailsData" variant={messageCode === 200 ? "" : mapMessageCodeToIcon(messageCode)} open={(!!message)} body={message} onCloseModal={cleanMessageInternal} />
					<div className={classes.appBarSpacer} />
					<EasyPaySlipPtyRegisterComponent mixpanel={mixpanel} />
				</main>
			</div>
		);
	}
}

EasyPaySlipPtyRegisterPage.propTypes = {
	classes: PropTypes.object.isRequired,
	isLoading: PropTypes.bool,
	messageCode: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	message: PropTypes.string
};

const mapStateToProps = state => ({
	isLoading: state.accountantDetails.isLoading,
	messageCode: state.accountantDetails.messageCode,
	message: state.accountantDetails.message
});

const mapDispatchToProps = dispatch => ({
	cleanMessageInternal: bindActionCreators(cleanMessage, dispatch)
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withStyles(SessionUserStyles)(EasyPaySlipPtyRegisterPage));
